import {
  GET_CAE,
  ADD_CAE,
  UPDATE_CAE,
  DELETE_CAE,
  ERROR_XHR
} from '../mutation-types'

import toastr from 'toastr'

const state = {
  all: []
}

const mutations = {
  [GET_CAE] (state, caes) {
    state.all = caes
  },
  [ADD_CAE] (state, project) {
    state.all.push(project)
    toastr.success('Le CAE a été créé')
  },
  [UPDATE_CAE] (state, oldProject, updatedProject) {
    state.all.$remove(oldProject)
    state.all.push(updatedProject)
    toastr.success('Le CAE a été modifié')
  },
  [DELETE_CAE] (state, project) {
    state.all.$remove(project)
    toastr.success('Le CAE a été supprimé')
  },
  [ERROR_XHR] (state, error) {
    console.log(state)
    console.log(error)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/caes.js